import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    '& > div': {
      marginBottom: 20,
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  groupInfoWrapper: {
    padding: 15,
  },
  groupInfoTitle: {
    margin: 0,
    marginBottom: 8,
    fontSize: 15,
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  flex: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));
